<template>
    <div class="Index">

        <div class="company-index-c">
            <div class="bnner-info">
                <el-carousel height="550px">
                    <el-carousel-item v-for="item in bannerlist" @click="openPage(item.jumpUrl)">
                        <el-image @click="openPage(item.jumpUrl)"
                                  style="width: 100%; height: 100%;cursor: pointer;"
                                  :src="item.imageUrl"
                                  fit="cover"></el-image>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <div class="company-core-products">
            <div class="title1">数字酒店管理运营平台</div>
            <img style="width: 100%;" src="../../assets/images/about2.jpg"/>
        </div>
        <div style="width:100%;text-align: center;margin-top: 60px;">
            <h2 class="section-title">
                智慧酒店、新体验、更高效、更快捷
            </h2>
        </div>
        <div class="row">
            <div class="col-xl-3 col-lg-3 col-md-6">
                <div class="feabox mb-30">
                    <div class="feabox__img mb-50">
                        <img src="../../assets/images/Forma1.png" alt="form1">
                    </div>
                    <div class="feabox__content">
                        <h3 class="feabox-title tcolor0">在线订房 </h3>
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6">
                <div class="feabox mb-30 clr1">
                    <div class="feabox__img img1 mb-50">
                        <img src="../../assets/images/Forma2.png" alt="form2">
                    </div>
                    <div class="feabox__content">
                        <h3 class="feabox-title tcolor1">在线入住 </h3>
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6">
                <div class="feabox mb-30 clr2">
                    <div class="feabox__img img2 mb-50">
                        <img src="../../assets/images/Forma3.png" alt="form3">
                    </div>
                    <div class="feabox__content">
                        <h3 class="feabox-title tcolor2">在线退房 </h3>
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6">
                <div class="feabox mb-30 clr3">
                    <div class="feabox__img img3 mb-50">
                        <img src="../../assets/images/Forma4.png" alt="form4">
                    </div>
                    <div class="feabox__content">
                        <h3 class="feabox-title tcolor3">语音客控 </h3>
                    </div>
                </div>
            </div>
        </div>
        <div class="company-core-products">
            <div class="title1">智能硬件</div>
        </div>
        <div style="position: relative;width: 100%;height: 400px;overflow-x: hidden;">
            <div class="gundong-1">
                <div class="gundong-item">
                    <div>
                        <img style="width: 100px;height: 100px;" src="../../assets/images/开关D1.png"/>
                        <div class="kg-desc">D系列单开</div>
                    </div>

                </div>
                <div class="gundong-item">
                    <div>
                        <img style="width: 100px;height: 100px;" src="../../assets/images/开关D2.png"/>
                        <div class="kg-desc">D系列双开</div>
                    </div>

                </div>
                <div class="gundong-item">
                    <div>
                        <img style="width: 100px;height: 100px;" src="../../assets/images/开关D3.png"/>
                        <div class="kg-desc">D系列三开</div>
                    </div>

                </div>
                <div class="gundong-item">
                    <div>
                        <img style="width: 100px;height: 100px;" src="../../assets/images/开关T2.png"/>
                        <div class="kg-desc">T系列单开</div>
                    </div>

                </div>
                <div class="gundong-item">
                    <div>
                        <img style="width: 100px;height: 100px;" src="../../assets/images/开关T1.png"/>
                        <div class="kg-desc">T系列双开</div>
                    </div>
                </div>
                <div class="gundong-item">
                    <div>
                        <img style="width: 100px;height: 100px;" src="../../assets/images/开关T2.png"/>
                        <div class="kg-desc">T系列三开</div>
                    </div>
                </div>
                <div class="gundong-item">
                    <div>
                        <img style="width: 100px;height: 100px;" src="../../assets/images/开关D1.png"/>
                        <div class="kg-desc">D系列单开</div>
                    </div>

                </div>
                <div class="gundong-item">
                    <div>
                        <img style="width: 100px;height: 100px;" src="../../assets/images/开关D2.png"/>
                        <div class="kg-desc">D系列双开</div>
                    </div>

                </div>
                <div class="gundong-item">
                    <div>
                        <img style="width: 100px;height: 100px;" src="../../assets/images/开关D3.png"/>
                        <div class="kg-desc">D系列三开</div>
                    </div>

                </div>
                <div class="gundong-item">
                    <div>
                        <img style="width: 100px;height: 100px;" src="../../assets/images/开关T2.png"/>
                        <div class="kg-desc">T系列单开</div>
                    </div>

                </div>
                <div class="gundong-item">
                    <div>
                        <img style="width: 100px;height: 100px;" src="../../assets/images/开关T1.png"/>
                        <div class="kg-desc">T系列双开</div>
                    </div>
                </div>
                <div class="gundong-item">
                    <div>
                        <img style="width: 100px;height: 100px;" src="../../assets/images/开关T2.png"/>
                        <div class="kg-desc">T系列三开</div>
                    </div>
                </div>

            </div>
            <div class="gundong-2">
                <div class="gundong-item">
                    <div>
                        <img style="width: 100px;height: 100px;" src="../../assets/images/kanying.png"/>
                        <div class="kg-desc">智云感</div>
                    </div>
                </div>
                <div class="gundong-item">
                    <div>
                        <img style="width: 100px;height: 100px;" src="../../assets/images/czD.png"/>
                        <div class="kg-desc">D系列智电插</div>
                    </div>
                </div>
                <div class="gundong-item">
                    <div>
                        <img style="width: 100px;height: 100px;" src="../../assets/images/czT.png"/>
                        <div class="kg-desc">T系列智电插</div>
                    </div>
                </div>
                <div class="gundong-item">
                    <div>
                        <img style="width: 100px;height: 100px;" src="../../assets/images/wnykq.png"/>
                        <div class="kg-desc">红外转发器</div>
                    </div>
                </div>
                <div class="gundong-item">
                    <div>
                        <img style="width: 100px;height: 100px;" src="../../assets/images/znms.png"/>
                        <div class="kg-desc">智能门锁</div>
                    </div>

                </div>
                <div class="gundong-item">
                    <div>
                        <img style="width: 100px;height: 100px;" src="../../assets/images/cldj.png"/>
                        <div class="kg-desc">窗帘电机</div>
                    </div>
                </div>
                <div class="gundong-item">
                    <div>
                        <img style="width: 100px;height: 100px;" src="../../assets/images/kanying.png"/>
                        <div class="kg-desc">智云感</div>
                    </div>
                </div>
                <div class="gundong-item">
                    <div>
                        <img style="width: 100px;height: 100px;" src="../../assets/images/czD.png"/>
                        <div class="kg-desc">D系列智电插</div>
                    </div>
                </div>
                <div class="gundong-item">
                    <div>
                        <img style="width: 100px;height: 100px;" src="../../assets/images/czT.png"/>
                        <div class="kg-desc">T系列智电插</div>
                    </div>
                </div>
                <div class="gundong-item">
                    <div>
                        <img style="width: 100px;height: 100px;" src="../../assets/images/wnykq.png"/>
                        <div class="kg-desc">红外转发器</div>
                    </div>
                </div>
                <div class="gundong-item">
                    <div>
                        <img style="width: 100px;height: 100px;" src="../../assets/images/znms.png"/>
                        <div class="kg-desc">智能门锁</div>
                    </div>

                </div>
                <div class="gundong-item">
                    <div>
                        <img style="width: 100px;height: 100px;" src="../../assets/images/cldj.png"/>
                        <div class="kg-desc">窗帘电机</div>
                    </div>
                </div>

            </div>
        </div>
        <div style="width: 1290px;margin: auto;display: flex;margin-top: 40px;margin-bottom: 40px;">
            <div class="ewm-item">
                <img style="width: 150px;" src="../../assets/images/腾宇慧住app下载.png"/>
                <div>扫码下载腾宇慧住APP</div>
            </div>
            <div class="ewm-item">
                <img style="width: 150px;" src="../../assets/images/腾宇管家app下载.png"/>
                <div>扫码下载腾宇管家APP</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getBannerListByType} from '../../api/banner.js'

    export default {
        name: 'Index',
        data() {
            return {
                screenWidth: 1200,
                bannerlist: []
            }
        },
        mounted() {
            const that = this
            window.onresize = () => {
                return (() => {
                    that.screenWidth = window.screenWidth
                })()
            }
        },
        created() {
            this.getBannerList()
        },
        methods: {
            getBannerList() {
                getBannerListByType({type: null}).then(res => {
                    console.log(res)
                    this.bannerlist = res.data
                })
            },
            openPage(url) {
                if (url == '') {
                    return false;
                }
                console.log(url)
                this.$router.push({path: url})
            }
        }

    }
</script>

<style>
    .Index {
        width: 100%;
        min-width: 900px;
        margin: 0;
        overflow-x: hidden;
    }

    .company-core-products {
        width: 1290px;
        margin: 30px auto;
    }

    .company-core-products .title1 {
        font-size: 40px;
        font-weight: bold;
    }

    .section-title {
        font-size: 30px;
        font-weight: 600;
        padding-bottom: 3px;
        line-height: 1.2;
        -webkit-transition: all 0.3s linear 0s;
        -moz-transition: all 0.3s linear 0s;
        -ms-transition: all 0.3s linear 0s;
        -o-transition: all 0.3s linear 0s;
        transition: all 0.3s linear 0s;
        margin-bottom: 30px;
        margin-top: -150px;
    }

    .row {
        display: flex;
        flex-wrap: wrap;
        margin-top: 0;
        width: 1290px;
        margin: auto;
    }

    .col-xl-3 {
        flex: 0 0 auto;
        width: 25%;
    }

    .feabox {
        display: grid;
        place-items: center;
        background: #f4f7ff;
        text-align: center;
        transition: 0.3s;
        border-radius: 10px;
        padding-top: 50px;
        padding-bottom: 50px;
        width: 94%;
        margin-left: 3%;
    }

    .mb-30 {
        margin-bottom: 30px;
    }

    .feabox__img {
        height: 80px;
        width: 80px;
        border-radius: 50%;
        background-image: linear-gradient(-120deg, #56bbff 1%, #3d7bff 100%);
        line-height: 80px;
        text-align: center;
        box-shadow: 0px 20px 40px 0px rgb(5 42 18 / 14%);
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .mb-50 {
        margin-bottom: 50px;
    }

    .feabox-title {
        font-size: 20px;
        font-weight: 600;
        margin-top: -18px;
    }

    .tcolor0 {
        color: #3d7bff;
    }

    .tcolor1 {
        color: #19cb55;
    }

    .tcolor2 {
        color: #faaa0f;
    }

    .tcolor3 {
        color: #766eff;
    }

    .feabox.clr1 {
        border-radius: 10px;
        background-color: #f1fcf5;
        color: #19cb55;
    }

    .feabox.clr2 {
        background: #fff8ec;
    }

    .feabox.clr3 {
        background: #f7f6ff;
    }

    .feabox__img.img1 {
        background-image: linear-gradient(-120deg, #57e988 1%, #19cb55 100%);
    }

    .feabox__img.img2 {
        background-image: linear-gradient(-120deg, #fbd275 1%, #faaa0f 100%);
    }

    .feabox__img.img3 {
        background-image: linear-gradient(-120deg, #c2b7ff 1%, #766eff 100%);
    }

    .gundong-1 {
        width: 200vw;
        min-width: 2580px;
        height: 200px;
        position: absolute;
        top: 0;
        right: 0;
        animation: mymove 40s linear 1s infinite;
        display: flex;
    }

    .gundong-2 {
        width: 200vw;
        min-width: 2580px;
        height: 200px;
        position: absolute;
        top: 200px;
        left: 0;
        animation: mymove1 40s linear 1s infinite;
        display: flex;
    }

    .gundong-1:hover {
        animation-play-state: 'paused'
    }

    .gundong-item {
        width: 16.66%;
        height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;

    }

    .kg-desc {
        margin-top: 20px;
    }

    .ewm-item {
        margin-right: 30px;
    }

    @keyframes mymove {
        from {
            transform: translateX(0);
        }
        to {
            transform: translateX(50%);
        }
    }

    @keyframes mymove1 {
        from {
            transform: translateX(0);
        }
        to {
            transform: translateX(-50%);
        }
    }
</style>